import { render, staticRenderFns } from "./LayoutNoToken.vue?vue&type=template&id=7b7c4ff4&scoped=true&"
import script from "./LayoutNoToken.vue?vue&type=script&lang=ts&"
export * from "./LayoutNoToken.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutNoToken.vue?vue&type=style&index=0&id=7b7c4ff4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7c4ff4",
  null
  
)

export default component.exports